const state = {
  dataCPConf: [],
  layoutCPConf: {},
  concentrationsCPConf: [],
  stepSizeCPConf: -1,
  selectedXValueCPConf: 0,
  selectedConcCPConf: 0,
  selectedIndxCPConf: -1,
  selectionFlagCPConf: false
}

const getters = {
  getDataCPConf: state => state.dataCPConf,
  getLayoutCPConf: state => state.layoutCPConf,
  getConcentrationsCPConf: state => state.concentrationsCPConf,
  getStepSizeCPConf: state => state.stepSizeCPConf,
  getSelectedXAxisCPConf: state => state.selectedXValueCPConf,
  getSelectConcCPConf: state => state.selectedConcCPConf,
  getSelectedIndxCPConf: state => state.selectedIndxCPConf,
  isSelectedCPConf: state => state.selectionFlagCPConf
}

const actions = {
  setPlotCPConf ({ commit }, { data, layout, concentrations }) {
    commit('SET_LAYOUT_CPConf', layout)
    commit('SET_DATA_CPConf', data)
    commit('SET_CONCENTRATION_CPConf', concentrations)
  },
  setStepSizeCPConf ({ commit }, newStepSize) {
    newStepSize = Math.abs(newStepSize)// Always positive
    newStepSize = Math.round(newStepSize * 10) / 10// Round one decimals
    commit('SET_STEP_SIZE_CPConf', newStepSize)
  },
  setSelectedXAxisCPConf ({ commit, state }, newXValue) {
    newXValue = Math.round(newXValue * 100) / 100 // Round two decimals
    if (state.selectionFlagCPConf) {
      let concentrations = state.concentrationsCPConf
      concentrations[state.selectedIndxCPConf][0] = newXValue
      commit('SET_CONCENTRATION_CPConf', concentrations)
    }
    commit('SET_SELECTED_X_AXIS_CPConf', newXValue)
  },
  setSelectedConcCPConf ({ commit, state }, newConc) {
    if (state.selectionFlagCPConf) {
      let concentrations = state.concentrationsCPConf
      concentrations[state.selectedIndxCPConf][1] = newConc
      commit('SET_CONCENTRATION_CPConf', concentrations)
      //commit('UPDATE_CONCENTRATION_VALUE_CPConf', { id: state.selectedIndxCPConf, value: newConc })
    }
    commit('SET_SELECTED_CONC_CPConf', newConc)
  },
  setSelectedIndxCPConf ({ commit, state }, newIndx) {
    commit('SET_SELECTED_INDX_CPConf', newIndx)
    if(newIndx<0){
      return
    }
    commit('SET_SELECTED_CONC_CPConf', state.concentrationsCPConf[newIndx][1])
  },
  setSelectionFlagCPConf ({ commit }, newBool) {
    commit('SET_SELECTION_FLAG_CPConf', newBool)
  },
  updateXAxisConcCPConf({ commit },{index,newXVal}){
    let concentrations = state.concentrationsCPConf
    concentrations[index][0] = newXVal
    commit('SET_CONCENTRATION_CPConf', concentrations)
  },
  updateTableConcCPConf({ commit,state },{row,arrIndex,newXVal}){
    let concentrations = state.concentrationsCPConf
    concentrations[row][arrIndex] = newXVal
    commit('SET_CONCENTRATION_CPConf', concentrations)
  },
  addConcentrationCPConf ({ commit, state }, xValue) {
    let newConc=1 //This is the value by defult
    let concentrations = state.concentrationsCPConf
    if(concentrations.length===1){
      newConc = concentrations[0][1] //If there is one element, it would copy the same value
    }
    else if(concentrations.length>1){//If there is more than one, it would calculate the average
      newConc=0
      for(let j=0;j<concentrations.length;j++){
        newConc+=concentrations[j][1]
      }
      newConc/=concentrations.length
    }
    newConc = Math.round(newConc * 100) / 100
    
    concentrations.push([xValue,newConc])
    //concentrations.sort(function(a, b){return a[0] - b[0]})
    commit('SET_CONCENTRATION_CPConf', concentrations)
  },
  deleteConcentrationCPConf ({ commit }, index) {
    let concentrations = state.concentrationsCPConf
    concentrations.splice(index, 1)
    commit('SET_CONCENTRATION_CPConf', concentrations)
  },
  resetConcentrationCPConf({ commit }){
    commit('SET_CONCENTRATION_CPConf', [])
  },
  setShapesGraphCPConf({ commit }, newShapes){
    commit('SET_SHAPES_GRAPH_CPConf', newShapes)
  },
  setConcentrationCPConf({ commit }, newConc){
    commit('SET_CONCENTRATION_CPConf', newConc)
  },
}

const mutations = {
  SET_DATA_CPConf: (state, dataCPConf) => (state.dataCPConf = dataCPConf),
  SET_LAYOUT_CPConf: (state, layoutCPConf) => (state.layoutCPConf = layoutCPConf),
  SET_STEP_SIZE_CPConf: (state, stepSize) => (state.stepSizeCPConf = stepSize),
  SET_SELECTED_X_AXIS_CPConf: (state, XValue) => (state.selectedXValueCPConf = XValue),
  SET_SELECTED_CONC_CPConf: (state, conc) => (state.selectedConcCPConf = conc),
  SET_SELECTED_INDX_CPConf: (state, indx) => (state.selectedIndxCPConf = indx),
  SET_SELECTION_FLAG_CPConf: (state, boolVal) => (state.selectionFlagCPConf = boolVal),
  SET_CONCENTRATION_CPConf: (state, newConcs) => (state.concentrationsCPConf = newConcs), //It is possible to trigger the watch event, by changing this commits to $set
  SET_SHAPES_GRAPH_CPConf: (state, newShapes) => (state.layoutCPConf.shapes = newShapes)
}

export default {
  state,
  getters,
  actions,
  mutations
}
